import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { UseCaseProvider } from './contexts/UseCaseContext';
import { PeriodProvider } from './contexts/PeriodContext';
import { DataReadinessProvider } from './contexts/DataReadinessContext';
import { DataFeedProvider } from './contexts/DataFeedContext';
import { DemoModeProvider } from './contexts/DemoModeContext';
import { OptimizationScopeProvider } from './contexts/OptimizationScopeContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { ProfitabilitySnapshotProvider } from './contexts/ProfitabilitySnapshotContext';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <UseCaseProvider>
      <PeriodProvider>
        <DataReadinessProvider>
          <DataFeedProvider>
            <DemoModeProvider>
              <ConfigProvider>
                <ProfitabilitySnapshotProvider>
                  <OptimizationScopeProvider>
                    <App />
                  </OptimizationScopeProvider>
                </ProfitabilitySnapshotProvider>
              </ConfigProvider>
            </DemoModeProvider>
          </DataFeedProvider>
        </DataReadinessProvider>
      </PeriodProvider>
    </UseCaseProvider>
  </StrictMode>
);
